<template>
  <div class="insure-form-payment">
    <div class="loading" v-if="loading">
      <img src="@/assets/loading.gif" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    this.replaceUrl();
  },

  methods: {
    replaceUrl() {
      const { realNameUrl } = this.$route.query;
      if (realNameUrl) {
        window.location.replace(realNameUrl);
      }
    },
  },
};
</script>

<style lang="less">
.insure-form-payment {
  display: flex;
  align-items: center;
  height: 100%;
  .loading {
    margin: 0 auto;
    img {
      width: 80vw;
    }
  }
}
</style>
